import { memo, useContext, useEffect } from 'react';
import { DataContext } from '../../store';
import PageLayout from '../../layouts/PageLayout';
import { TipoModulo } from '../../helpers/enums';

const FolhaBeneficio = memo(() => {
	const { changeTipoModulo, arquivos, isError } = useContext(DataContext);

	useEffect(() => {
		changeTipoModulo(TipoModulo.FolhaBeneficio);
	}, [changeTipoModulo]);

	return <PageLayout arquivos={arquivos} isError={isError} />;
});

export default FolhaBeneficio;
